import React from "react";

function Footer() {
  return (
    <footer>
      <div>
        <a target="_blank" href="https://github.com/SauravBhandari93/Pokedex">
          GitHub Link
        </a>
      </div>
    </footer>
  );
}

export default Footer;
